﻿/*
 * @class rlLazyLoad
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlLazyLoad = function () {

        //initialise lazyload
        $('.lazyload').lazy({
            threshold: 100
        });


        //Multi Asset Block lazyload that rematches heights of blocks on load
        $('.lazyloadmultiasset').lazy({
            afterLoad: function () {
                $('.multi-asset-container-block .img-container').matchHeight();
            }
        });

    }
}(jQuery));